import { debitNormsService } from '@/services/debit-norms/debit-norms-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';
import { computed, toValue, type MaybeRefOrGetter } from 'vue';

export const useAtaDebitNormsQuery = (projectId: MaybeRefOrGetter<string>) =>
  useQuery({
    queryKey: computed(() =>
      projectKeys.debitNorms({ projectId: toValue(projectId) }),
    ),
    queryFn: () =>
      debitNormsService.getDebitNormsForProject(toValue(projectId)),
    enabled: computed(() => !!toValue(projectId)),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
